module.exports = __webpack_public_path__ + "img/IMG_3539_L.1fec77bc.webp";